const STATUS_CLASSES = {
  over: { bg: "bg-red-50", text: "text-red-700", label: "Above avg" },
  under: { bg: "bg-emerald-50", text: "text-emerald-700", label: "Below avg" },
  normal: { bg: "bg-stone-50", text: "text-stone-600", label: "On track" }
}

export function renderBudgetBreakdown(tbody, breakdown, formatMoney) {
  tbody.innerHTML = breakdown.map(row => {
    const s = STATUS_CLASSES[row.status] || STATUS_CLASSES.normal
    const diffSign = row.difference > 0 ? "+" : ""

    return `
      <tr class="border-b border-stone-100 hover:bg-stone-50">
        <td class="px-4 py-2 text-stone-700">${row.label}</td>
        <td class="px-4 py-2 text-right money-value">${formatMoney(row.amount)}</td>
        <td class="px-4 py-2 text-right text-stone-600">${row.percentage}%</td>
        <td class="px-4 py-2 text-right text-stone-500">${row.nz_average_percentage}%</td>
        <td class="px-4 py-2 text-right">
          <span class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${s.bg} ${s.text}">
            ${diffSign}${row.difference}pp
          </span>
        </td>
      </tr>
    `
  }).join("")
}

export function renderInsights(container, insights) {
  if (!insights || insights.length === 0) {
    container.innerHTML = `
      <div class="rounded-lg bg-stone-50 p-4 text-sm text-stone-600">
        Your spending is broadly in line with NZ averages for your income bracket.
      </div>
    `
    return
  }

  container.innerHTML = insights.map(insight => {
    const isWarning = insight.type === "warning"
    const bg = isWarning ? "bg-amber-50 border-amber-200" : "bg-emerald-50 border-emerald-200"
    const text = isWarning ? "text-amber-800" : "text-emerald-800"
    const icon = isWarning ? "&#9888;" : "&#10003;"

    return `
      <div class="rounded-lg border ${bg} p-3 text-sm ${text} flex gap-2">
        <span class="mt-0.5 shrink-0">${icon}</span>
        <span>${insight.message}</span>
      </div>
    `
  }).join("")
}
